import React, { useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { ApiContext } from '_lib/api/apiContext';
import { CallCenterDetailDTO, Company } from '_lib/api/apiTypes.shim';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';

import {
  CompanyConfigSettingsForm,
  CompanyConfigSettingsFormValues,
  companyConfigSettingsFormValues
} from '../../CompanyFormItems/CompanyConfigSettingsForm/CompanyConfigSettingsForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';

export type CompanyConfigSettingsProps = {
  company: Company;
  callCenter: CallCenterDetailDTO;
  authUser: AuthUser;
  tabChangeObj: TabChangeObj;
};

export const CompanyConfigSettings = (props: CompanyConfigSettingsProps) => {
  const { company, authUser, callCenter, tabChangeObj } = props;
  const api = useContext(ApiContext);
  const aiVoicesQuery = api.appConfig.useAiVoiceConfigQuery();

  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyConfigSettingsFormValues,
    tabChangeObj,
    snackMessage: 'Company settings saved'
  });

  return (
    <FormWrapper
      isFetchingOrPending={isPending || aiVoicesQuery.isFetching}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      <CompanyConfigSettingsForm
        companyConfigSettingsFormContext={
          // TODO: there is a bug with the DTO typing, similar to the 'address' fields, where we are missing the reporting fields
          companyUpdateFormContext as unknown as UseFormReturn<CompanyConfigSettingsFormValues>
        }
        callCenter={callCenter}
        company={company}
        aiVoices={
          aiVoicesQuery.data?.results
            .filter((voice) => voice.isActive)
            .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)) || []
        }
        voicesAreLoading={aiVoicesQuery.isFetching}
        onSave={handleSave}
      />
    </FormWrapper>
  );
};
